/**
 * Fiskal Cloud Statistics API
 * # Overview  Statistics API is used for  * read statistics about FC data (tenants, business premises, organizations, ERSes, TSS, ...) or transactions  ## Getting an authentication token  To be able to work with the API you need to get an authentication token to use with all subsequent API calls described below. Get the token via the [Oauth endpoint](https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token) of the Fiskal Cloud. Use client_id=df-api and grant_type=password for requesting a token. > The access token grants same access rights as the user has in the Fiskal Cloud Portal.  Example request to get token via curl: ``` curl -X POST \\ https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token \\ -H \'Accept: application/json\' \\ -H \'Content-Type: application/x-www-form-urlencoded\' \\ -d \'username=<USER_EMAILADDRESS>&password=<USER_PASSWORD>&client_id=df-api&grant_type=password\' ``` Save the access_token entry of the response and pass it as bearer token in all subsequent API calls. Pass it as header parameter. ```\'Authorization: Bearer <ACCESS_TOKEN_FROM_AUTHENTICATION>\'```  For details on access tokens, please check general Oauth documentation like [Oauth.com](https://www.oauth.com/oauth2-servers/access-tokens/access-token-response/)  ## Tenant context All methods of this API work in the context of the logged in user\'s tenant account. For creating new elements you need to set the tenant id in the request. You can retrieve your tenant id by using the /tenants/tenant endpoint. It is fixed, so it can safely stored for later use.  ## Managed Tenant You can use a different tenant for operations if you have a permission to managed them. You can select managed tenant by sending `X-Managed-Tenant` header with `tenantId` of the managed tenant. All operations (creating, updating and getting) are done in the context of the managed tenant with this header.  ``` curl -X GET \\ -i \'https://fiskal.cloud/api/statistics/tenant-statistics\' \\ -H \'Authorization: Bearer {{AccessToken}}\' \\ -H \'X-Managed-Tenant: {{managedTenantId}}\' ```  # Changelog ## 0.4.0 * Add Swissbit 
 *
 * The version of the OpenAPI document: 0.4.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { GlobalStatisticsResponseDTO } from '../model/global-statistics-response-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    GlobalApiClientInterface,
    GetGlobalStatisticsRequestParams
} from './global-api-client.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class GlobalApiClient implements GlobalApiClientInterface {

    protected basePath = 'https://fiskal.cloud/api/statistics';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Retrieve the global statistics
     * Get statistics for the cloud platform of one day (from &#x60;00:00:00&#x60; to &#x60;23:59:59&#x60; &#x60;Europe/Berlin&#x60; time zone ). It\&#39;s possible to query by date (&#x60;DateQueryParam&#x60;), when not set defaults to &#x60;TODAY -1&#x60;. * Number of Transactions - Number of transactions per day * Number of Tenants per tenant type type * Total Number of Organizations - Number of active organizations * Total Number of Business Premises - Number of active business premises * Total Number of ERS - of ERS separated by active, disabled, suspended and inactive status * Total Number of TSS - Number of TSS separated by active, disabled, suspended and inactive status * Active TSS per mode - Number of TSS in status active per mode (token, cloud) 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGlobalStatistics(requestParameters: GetGlobalStatisticsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GlobalStatisticsResponseDTO>;
    public getGlobalStatistics(requestParameters: GetGlobalStatisticsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GlobalStatisticsResponseDTO>>;
    public getGlobalStatistics(requestParameters: GetGlobalStatisticsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GlobalStatisticsResponseDTO>>;
    public getGlobalStatistics(requestParameters: GetGlobalStatisticsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const date = requestParameters.date;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>date, 'date');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (df_auth) required
        localVarCredential = this.configuration.lookupCredential('df_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/global-statistics`;
        return this.httpClient.request<GlobalStatisticsResponseDTO>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
